// initial state
const state = () => ({
  productType: "",
  isPrintout: false,
  configuration: [],
});

// getters
const getters = {
  getConfiguration: (state) => {
    return state.configuration;
  },
  getProductType: (state) => {
    return state.productType;
  },
  isProductTemplated: (state) => {
    const templatedTypes = [];
    return !templatedTypes.includes(state.productType);
  },
};

// actions
const actions = {
  configureCustomizer({ commit }, configurationArgs) {
    commit("setConfiguration", configurationArgs);
  },
};

// mutations
const mutations = {
  setConfiguration(state, { productType, isPrintout, productOptions }) {
    state.productType = productType;
    state.isPrintout = isPrintout;

    const config = [];
    const { cushions, legs, sizes, fabrics, orientations, options } = productOptions;
    const baseFabricOptions = () => {
      if (fabrics.length) {
        config.push({
          type: "MODAL",
          heading: "Fabric",
          valueType: "FABRIC",
          modalHeading: "SELECT YOUR FABRIC",
          optionFunction: "fabrics/getFabrics",
          setFunction: "fabrics/activateFabric",
          defaultValueFunction: "fabrics/getDefaultFabric",
          emptyOptionFunction: "fabrics/getEmptyOption",
          activeOptionFunction: "fabrics/getActiveFabric",
          modalOpenOptionFunction: "fabrics/getChooseNowOption",
          modalCloseOptionFunction: "fabrics/getDecideLaterOption",
          chooseTextFunction: "fabrics/getChooseText",
          decideLaterTextFunction: "fabrics/getDecideLaterText",
          setStateFunction: "fabrics/setDecideLater",
          displayImage: true,
        });
      }
      if (legs.length) {
        config.push({
          type: "IMAGES",
          heading: "Leg",
          optionFunction: "legs/getLegs",
          setFunction: "legs/activateLeg",
          defaultValueFunction: "legs/getDefaultLeg",
          valueTypeFunction: "legs/getValueType",
          emptyOptionFunction: "legs/getEmptyOption",
          activeOptionFunction: "legs/getActiveLeg",
          displayImage: true,
          isThumbnail: true,
        });
      }
      if (cushions.length) {
        config.push({
          type: "DROPDOWN",
          heading: "Cushion Type",
          optionFunction: "cushions/getCushions",
          setFunction: "cushions/activateCushion",
          defaultValueFunction: "cushions/getDefaultCushion",
          valueTypeFunction: "cushions/getValueType",
          emptyOptionFunction: "cushions/getEmptyOption",
          activeOptionFunction: "cushions/getActiveCushion",
        });
      }
      /*config.push({
        heading: "Qty",
        type: "QTY",
      });*/
      config.push({
        type: "ATC",
      });
    };
    const baseVariableOptions = () => {
      Object.keys(options).forEach((key) => {
        if (options[key].length) {
          config.push({
            key,
            type: "VARIANT_DROPDOWN",
            labelFunction: "options/getLabel",
            optionFunction: "options/getOption",
            setFunction: "options/activateOption",
            defaultValueFunction: "options/getDefaultOption",
            activeOptionFunction: "options/getActiveOption",
            emptyOptionFunction: "options/getEmpty",
            setStateFunction: "options/activateOption",
          });
        }
      })
    }
    switch (productType) {
      case "Sofa":
        if (sizes.width_1) {
          config.push({
            type: "SIZE_DROPDOWN",
            heading: "Width",
            sizeKey: "width_1",
            optionFunction: "sizes/getSizes",
            setFunction: "sizes/activateSize",
            defaultValueFunction: "sizes/getDefaultSize",
            emptyOptionFunction: "sizes/getEmptyOption",
            activeOptionFunction: "sizes/getActiveSize",
            activeLabelFunction: "sizes/getActiveLabel",
            formatter: "sizes/getFormatter",
          });
        }
        baseFabricOptions();
        break;
      case "Chaise":
        if (orientations.length) {
          config.push({
            type: "RADIO",
            heading: "Faces",
            optionFunction: "orientations/getOrientations",
            setFunction: "orientations/activateOrientation",
            defaultValueFunction: "orientations/getDefaultOrientation",
            emptyOptionFunction: "orientations/getEmptyOption",
            activeOptionFunction: "orientations/getActiveOrientation",
            windowEvent: "orientation-changed",
          });
        }
        baseFabricOptions();
        break;
      case "Sofa with Chaise":
        if (orientations.length) {
          config.push({
            type: "RADIO",
            heading: "Chaise Side",
            optionFunction: "orientations/getOrientations",
            setFunction: "orientations/activateOrientation",
            defaultValueFunction: "orientations/getDefaultOrientation",
            emptyOptionFunction: "orientations/getEmptyOption",
            activeOptionFunction: "orientations/getActiveOrientation",
            windowEvent: "orientation-changed",
          });
        }
        if (sizes.width_1) {
          config.push({
            type: "SIZE_DROPDOWN",
            heading: "Sofa Width",
            sizeKey: "width_1",
            optionFunction: "sizes/getSizes",
            setFunction: "sizes/activateSize",
            defaultValueFunction: "sizes/getDefaultSize",
            emptyOptionFunction: "sizes/getEmptyOption",
            activeOptionFunction: "sizes/getActiveSize",
            activeLabelFunction: "sizes/getActiveLabel",
            formatter: "sizes/getFormatter",
          });
        }
        baseFabricOptions();
        break;
      case "Sectional":
        if (orientations.length) {
          config.push({
            type: "RADIO",
            heading: "Corner",
            optionFunction: "orientations/getOrientations",
            setFunction: "orientations/activateOrientation",
            defaultValueFunction: "orientations/getDefaultOrientation",
            emptyOptionFunction: "orientations/getEmptyOption",
            activeOptionFunction: "orientations/getActiveOrientation",
            windowEvent: "orientation-changed",
          });
        }
        if (sizes.width_1) {
          config.push({
            type: "SIZE_DROPDOWN",
            sizeKey: "width_1",
            optionFunction: "sizes/getSizes",
            setFunction: "sizes/activateSize",
            defaultValueFunction: "sizes/getDefaultSize",
            emptyOptionFunction: "sizes/getEmptyOption",
            activeOptionFunction: "sizes/getActiveSize",
            activeLabelFunction: "sizes/getActiveLabel",
            formatter: "sizes/getFormatter",
            multipleWidth: sizes.width_2 ? true : false,
          });
        }
        if (sizes.width_2) {
          config.push({
            type: "SIZE_DROPDOWN",
            sizeKey: "width_2",
            optionFunction: "sizes/getSizes",
            setFunction: "sizes/activateSize",
            defaultValueFunction: "sizes/getDefaultSize",
            emptyOptionFunction: "sizes/getEmptyOption",
            activeOptionFunction: "sizes/getActiveSize",
            activeLabelFunction: "sizes/getActiveLabel",
            formatter: "sizes/getFormatter",
            multipleWidth: sizes.width_1 ? true : false,
          });
        }
        baseFabricOptions();
        break;
      case "Sectional with Bumper":
        if (orientations.length) {
          config.push({
            type: "RADIO",
            heading: "Bumper",
            optionFunction: "orientations/getOrientations",
            setFunction: "orientations/activateOrientation",
            defaultValueFunction: "orientations/getDefaultOrientation",
            emptyOptionFunction: "orientations/getEmptyOption",
            activeOptionFunction: "orientations/getActiveOrientation",
            windowEvent: "orientation-changed",
          });
        }
        if (sizes.width_1) {
          config.push({
            type: "SIZE_DROPDOWN",
            sizeKey: "width_1",
            optionFunction: "sizes/getSizes",
            setFunction: "sizes/activateSize",
            defaultValueFunction: "sizes/getDefaultSize",
            emptyOptionFunction: "sizes/getEmptyOption",
            activeOptionFunction: "sizes/getActiveSize",
            activeLabelFunction: "sizes/getActiveLabel",
            formatter: "sizes/getFormatter",
          });
        }
        if (sizes.width_2) {
          config.push({
            type: "SIZE_DROPDOWN",
            sizeKey: "width_2",
            optionFunction: "sizes/getSizes",
            setFunction: "sizes/activateSize",
            defaultValueFunction: "sizes/getDefaultSize",
            emptyOptionFunction: "sizes/getEmptyOption",
            activeOptionFunction: "sizes/getActiveSize",
            activeLabelFunction: "sizes/getActiveLabel",
            formatter: "sizes/getFormatter",
          });
        }
        baseFabricOptions();
        break;
        case "U-Shaped Sectional":
        case "U-Shaped Sectional with Bumper":
          if (sizes.width_1) {
            config.push({
              type: "SIZE_DROPDOWN",
              sizeKey: "width_1",
              optionFunction: "sizes/getSizes",
              setFunction: "sizes/activateSize",
              defaultValueFunction: "sizes/getDefaultSize",
              emptyOptionFunction: "sizes/getEmptyOption",
              activeOptionFunction: "sizes/getActiveSize",
              activeLabelFunction: "sizes/getActiveLabel",
              formatter: "sizes/getFormatter",
            });
          }
          if (sizes.width_2) {
            config.push({
              type: "SIZE_DROPDOWN",
              sizeKey: "width_2",
              optionFunction: "sizes/getSizes",
              setFunction: "sizes/activateSize",
              defaultValueFunction: "sizes/getDefaultSize",
              emptyOptionFunction: "sizes/getEmptyOption",
              activeOptionFunction: "sizes/getActiveSize",
              activeLabelFunction: "sizes/getActiveLabel",
              formatter: "sizes/getFormatter",
            });
          }
          baseFabricOptions();
          break;
        case "U-Shaped Double Chaise Sectional":
        case "Bench Seat U-Shaped Double Chaise Sectional":
          if (sizes.width_2) {
            config.push({
              type: "SIZE_DROPDOWN",
              sizeKey: "width_2",
              optionFunction: "sizes/getSizes",
              setFunction: "sizes/activateSize",
              defaultValueFunction: "sizes/getDefaultSize",
              emptyOptionFunction: "sizes/getEmptyOption",
              activeOptionFunction: "sizes/getActiveSize",
              activeLabelFunction: "sizes/getActiveLabel",
              formatter: "sizes/getFormatter",
            });
          }
          baseFabricOptions();
          break;
        case "Bed":
          if (sizes.bed_size) {
            config.push({
              type: "SIZE_DROPDOWN",
              sizeKey: "bed_size",
              optionFunction: "sizes/getSizes",
              setFunction: "sizes/activateSize",
              defaultValueFunction: "sizes/getDefaultSize",
              emptyOptionFunction: "sizes/getEmptyOption",
              activeOptionFunction: "sizes/getActiveSize",
              activeLabelFunction: "sizes/getActiveLabel",
              formatter: "sizes/getFormatter",
              ignoreImages: true
            });
          }
          baseFabricOptions();
          break;
        case "Rug":
          baseVariableOptions()
          /*config.push({
            heading: "Qty",
            type: "QTY",
          });*/
          config.push({
            type: "ATC",
          });
          break;
        case "Modular Piece":
          if (orientations.length) {
            config.push({
              type: "RADIO",
              heading: orientations[0].includes('Bumper') ? "Bumper" : 'Faces',
              optionFunction: "orientations/getOrientations", 
              setFunction: "orientations/activateOrientation",
              defaultValueFunction: "orientations/getDefaultOrientation",
              emptyOptionFunction: "orientations/getEmptyOption",
              activeOptionFunction: "orientations/getActiveOrientation",
              windowEvent: "orientation-changed",
            });
          }
          baseFabricOptions();
          break;
        case "Modular Sectional":
          if (orientations.length) {
            config.push({
              type: "RADIO",
              heading: orientations[0].includes('Pass') ? "Pass Thru" : orientations[0].includes('Bumper') ? 'Bumper' : 'Faces',
              optionFunction: "orientations/getOrientations",
              setFunction: "orientations/activateOrientation",
              defaultValueFunction: "orientations/getDefaultOrientation",
              emptyOptionFunction: "orientations/getEmptyOption",
              activeOptionFunction: "orientations/getActiveOrientation",
              windowEvent: "orientation-changed",
            });
          }
          baseFabricOptions();
          break;
        default:
          baseFabricOptions();
    }

    state.configuration = config;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
